// extracted by mini-css-extract-plugin
export default {"button":"Button-button_THN10"};